import { render, staticRenderFns } from "./DistributionListList.vue?vue&type=template&id=705a2710&"
import script from "./DistributionListList.vue?vue&type=script&lang=js&"
export * from "./DistributionListList.vue?vue&type=script&lang=js&"
import style0 from "./DistributionListList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports